<mat-spinner *ngIf="isLoading" class="m-0 m-auto"></mat-spinner>
<ng-container *ngIf="!isLoading">
  <app-nav [selectedCase]="clientSelectedCase"></app-nav>
  <div style="background-color: #FAFBFB">
    <main role="main" class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-container>
